var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.id ? 'Edit' : 'Tambah') + " Dokumen Pensiun")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('form-line', {
    attrs: {
      "type": "text",
      "placeholder": "Contoh: Pensiun Normal"
    },
    model: {
      value: (_vm.contents.category),
      callback: function($$v) {
        _vm.$set(_vm.contents, "category", $$v)
      },
      expression: "contents.category"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.contents.documents), function(doc, dIndex) {
    return _c('div', {
      key: dIndex,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "row clearfix"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-10"
    }, [_c('form-line', {
      attrs: {
        "type": "text",
        "placeholder": "Contoh: Pensiun Normal"
      },
      model: {
        value: (doc.title),
        callback: function($$v) {
          _vm.$set(doc, "title", $$v)
        },
        expression: "doc.title"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row clearfix mt-2"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-10"
    }, [_c('ckeditor', {
      attrs: {
        "config": _vm.config
      },
      model: {
        value: (doc.content),
        callback: function($$v) {
          _vm.$set(doc, "content", $$v)
        },
        expression: "doc.content"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "text-right mt-2"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDocument(dIndex)
        }
      }
    }, [_vm._v("\n                Hapus Dokumen\n              ")])]), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success mb-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDocument
    }
  }, [_vm._v("\n            Tambah Dokumen\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" Simpan\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Batal\n              ")])])])], 2)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Form Dokumen Pensiun")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 form-control-label"
  }, [_c('label', [_vm._v("Nama kategori")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 form-control-label"
  }, [_c('label', [_vm._v("Judul Dokumen")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 form-control-label"
  }, [_c('label', [_vm._v("Konten")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc47022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/PensiunRegistrasi/FormPensiunType.vue
// module id = dxEG
// module chunks = 1